import Vue from 'vue/dist/vue.common.js';
import Vuex from 'vuex';

import menus from './modules/menus';
import pages from './modules/pages';
import acfOptions from './modules/acf-options';
import cases from './modules/cases';
import caseCategories from './modules/case-categories';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        menus,
        pages,
        acfOptions,
        cases,
        caseCategories,
    },

    state: {},

    mutations: {},

    actions: {},
    
    getters: {},
});